import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Button, Chip, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusChipData } from '../SelfService/SelfServiceComponents/components/AnalysisStatus';

interface HeapActionBarProps {
  onStartCapture?: () => void;
  onCancelCapture?: () => void;
  statusChips?: StatusChipData[];
}

export function HeapActionBar({ onStartCapture, onCancelCapture, statusChips = [] }: HeapActionBarProps): ReactElement {
  const { t } = useTranslation();
  const startCaptureDisabled = !onStartCapture;

  const actionButton = onCancelCapture ? (
    <Button
      variant='outlined'
      color='error'
      size='large'
      onClick={onCancelCapture}
      sx={{
        borderRadius: 2,
        height: '100%',
        minWidth: 220,
      }}
    >
      <Box display='flex' flexDirection='row' alignItems='center' gap={2}>
        <CancelIcon />
        <Typography variant='button'>{t('common.cancel')}</Typography>
      </Box>
    </Button>
  ) : (
    <Button
      variant='contained'
      size='large'
      onClick={onStartCapture}
      disabled={startCaptureDisabled}
      sx={{
        borderRadius: 2,
        height: '100%',
        minWidth: 220,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box display='flex' flexDirection='row' alignItems='center' gap={2}>
        <CameraAltIcon />
        <Typography variant='button'>{t('heap.startCapture')}</Typography>
      </Box>
    </Button>
  );

  return (
    <Box display='flex' gap={4}>
      {actionButton}
      <Box display='flex' flexDirection='row' flexWrap='wrap' gap={2} justifyContent='center' alignItems='center'>
        {statusChips.map(({ label, config }, index) => (
          <Chip
            key={index}
            label={
              <Box display='flex' alignItems='center' gap={0.5}>
                {t(label)}
                {config.icon}
              </Box>
            }
            sx={{
              backgroundColor: config.bgColor,
              color: config.color || 'white',
              '& .MuiChip-label': {
                paddingLeft: 1,
                paddingRight: 1,
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
